import { Schema } from "effect";
import { HttpApiEndpoint, HttpApiGroup, OpenApi } from "@effect/platform";
import { Authn } from "../authn";
import { Client } from "../../../schema/models";
export default HttpApiGroup.make("clientv1").annotate(OpenApi.Title, "Client V1").add(HttpApiEndpoint.get("getMeta")`/meta`.setUrlParams(Schema.Struct({
    platform: Schema.Literal("ios"),
    version: Schema.String
})).addSuccess(Client.Meta).annotate(OpenApi.Summary, "Get Meta")).prefix("/v1/client").middleware(Authn);
